export enum IdInputStatusEnum {
  VERIFYING = 'verifying',
  SUCCESS = 'success',
  DANGER = 'danger',
}
